import React from 'react';
import { Star, X } from 'lucide-react';

export const StarPicker = ({ value, onChange }) => (
  <div className="mbid-star-picker">
    {[1, 2, 3, 4, 5].map(s => (
      <button key={s} type="button" onClick={() => onChange(s)}>
        <Star
          size={26}
          fill={s <= value ? '#f59e0b' : '#e5e7eb'}
          color={s <= value ? '#f59e0b' : '#e5e7eb'}
        />
      </button>
    ))}
  </div>
);

const ReviewModal = ({ onClose, jobId, reviewData, onReviewChange, onSubmit }) => {
  const rv = reviewData || {};
  return (
    <div className="mjobs-modal-overlay" onClick={onClose}>
      <div className="mjobs-review-modal" onClick={e => e.stopPropagation()}>

        <div className="mjobs-review-modal__header">
          <div className="mjobs-review-modal__icon">
            <Star size={20} fill="#f59e0b" color="#f59e0b" />
          </div>
          <div>
            <h4 className="mjobs-review-modal__title">Rate & Review</h4>
            <p className="mjobs-review-modal__sub">Share your experience with the worker</p>
          </div>
          <button className="mjobs-dispute-modal__close" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="mjobs-review-modal__body">
          <div className="mjobs-review-modal__stars-label">Your Rating</div>
          <StarPicker
            value={rv.rating || 0}
            onChange={val => onReviewChange(jobId, 'rating', val)}
          />
          <div className="mjobs-dispute-modal__field" style={{ marginTop: 16 }}>
            <label>Your Review</label>
            <textarea
              placeholder="Write your experience..."
              value={rv.text || ''}
              onChange={e => onReviewChange(jobId, 'text', e.target.value)}
              rows={4}
            />
          </div>
        </div>

        <div className="mjobs-dispute-modal__footer">
          <button className="mjobs-dispute-modal__cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="mjobs-review-modal__submit-btn"
            onClick={() => { onSubmit(jobId); onClose(); }}
            disabled={!rv.rating}
          >
            <Star size={14} fill="currentColor" /> Submit Review
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReviewModal;